import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  const { t } = useTranslation("common")
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={12}>
              {t("copyright", { year: new Date().getFullYear() })}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
